import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {onMounted} from "vue";
import {
	IonContent,
	IonHeader,
	IonPage,
	IonTitle,
	IonToolbar
} from '@ionic/vue';
import ExploreContainer from '@/components/ExploreContainer.vue';
import AvatarMenu from "@/components/menu/AvatarMenu.vue";
import ChallengeNews from "@/components/challenge/ChallengeNews.vue";
import ActiveChallengeList from "@/components/challenge/ActiveChallengeList.vue";
import useChallenge from "@/composable/useChallenge";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChallengesTab',
  setup(__props) {

const challengeFacade = useChallenge();

onMounted(() => {
  challengeFacade.reloadChallenges();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("Challenges")
                ]),
                _: 1
              }),
              _createVNode(AvatarMenu, { "show-points": true })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), {
        fullscreen: true,
        class: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonHeader), { collapse: "condense" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonToolbar), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonTitle), { size: "large" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Challenges")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(ChallengeNews),
          _createVNode(ActiveChallengeList),
          _createVNode(ExploreContainer, { name: "Tab 1 page" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})